import { ref, nextTick } from 'vue';
import $ from 'jquery';

const popup = ref('');

function showPopup(msg, title) {
  if (typeof msg !== 'string') {
    throw new Error('no msseges!');
  } else {
    $('.popup__body').html(msg);
  }

  if (typeof title === 'string') {
    $('.popup__header > span').html(title);
  }
}

function closePopup() {
  popup.value = '';
}

function allPopupFn() {
  const o = {};

  o.alert = (msg, title) => {
    popup.value = 'alert';
    nextTick(() => {
      showPopup(msg, title);
    });
  };

  o.confirm = (msg, title) => {
    popup.value = 'confirm';
    nextTick(() => {
      showPopup(msg, title);
    });
  };

  o.special = (msg, title) => {
    popup.value = 'special';
    nextTick(() => {
      showPopup(msg, title);
    });
  };

  return o;
}

const popupDialog = allPopupFn();

function usePopup() {
  return { popup, popupDialog, showPopup, closePopup };
}

export default usePopup;
